import { Separator } from "@/components/ui/separator";
import SectionSubtitle from "../SectionSubtitle";

type ConversationStatsCardProps = {
  charged: number;
  total: number;
  value: number;
  conversationCost?: number;
  callMinutesCost?: number;
  outboundCost?: number;
  isInvoiced?: boolean;
  locale?: string;
};

const ConversationStatsCard = ({
  charged,
  total,
  value,
  conversationCost = 0,
  callMinutesCost = 0,
  outboundCost = 0,
  isInvoiced = false,
  locale = "es-ES",
}: ConversationStatsCardProps) => {
  const consumptionPercentage = total > 0 ? Number(((charged / total) * 100).toFixed(1)) : 0;

  const formatNumber = (num: number) => {
    return Math.round(num).toLocaleString(locale);
  };

  return (
    <div className="h-full rounded-lg border bg-card shadow-md">
      <div className="p-6">
        <div className="flex items-center justify-between gap-2">
          <SectionSubtitle subtitle="Estadísticas de Consumo" />
          {isInvoiced && (
            <span className="whitespace-nowrap rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
              Facturado
            </span>
          )}
        </div>

        <div className="mt-4 flex flex-col">
          <div>
            <p className="text-sm text-gray-secondary">Valor Total</p>
            <p className="text-2xl font-bold text-palomma-primary">${formatNumber(value)}</p>
            <p className="text-sm text-muted-foreground">Para el período de facturación actual</p>
          </div>

          <Separator className="my-4" />

          <div className="mb-4">
            <div className="mb-1 flex justify-between">
              <span className="font-medium text-gray-secondary">Consumo</span>
              <span className="font-medium">
                ${formatNumber(charged)} / ${formatNumber(total)}
              </span>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-md bg-gray-200">
              <div
                className="h-full rounded-md bg-purple-600 transition-all duration-300"
                style={{ width: `${Math.min(consumptionPercentage, 100)}%` }}
              />
            </div>
            <p className="mt-1 text-sm text-gray-secondary">
              {consumptionPercentage}% del valor total facturado
            </p>
          </div>

          {(conversationCost > 0 || callMinutesCost > 0 || outboundCost > 0) && (
            <>
              <Separator className="my-4" />
              <div>
                <p className="mb-2 font-medium text-gray-secondary">Desglose de costos</p>
                <div className="mb-1 flex justify-between">
                  <span className="text-sm text-gray-secondary">Conversaciones:</span>
                  <span className="text-sm font-medium">${formatNumber(conversationCost)}</span>
                </div>
                <div className="mb-1 flex justify-between">
                  <span className="text-sm text-gray-secondary">Plantillas salientes:</span>
                  <span className="text-sm font-medium">${formatNumber(outboundCost)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-secondary">Minutos de llamadas:</span>
                  <span className="text-sm font-medium">${formatNumber(callMinutesCost)}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConversationStatsCard;
